import React from 'react'
import classNames from 'classnames'
import { Carousel } from '@alto-avios/alto-ui'
import {
  ContentfulCard as ContentfulCardType,
  ContentfulCardStyle,
} from '@reward-platform/contentful'
import { ContentfulCard } from './ContentfulCard'
import { ContentfulCtaEventProps } from './eventTracking'
import styles from './ContentfulCardCarousel.module.scss'

type ContentfulCardCarouselProps = {
  cards: ContentfulCardType[]
  eventData: ContentfulCtaEventProps
  sectionName: string
  cardStyle?: ContentfulCardStyle
}

export const CAROUSEL_ITEMS_PER_PAGE = { base: 1, sm: 2, md: 3, lg: 5 } as const
export const CAROUSEL_SPACE_BETWEEN_ITEMS = 16

export const ContentfulCardCarousel = ({
  cards,
  eventData,
  sectionName,
  cardStyle = 'tall',
}: ContentfulCardCarouselProps) => {
  if (cards.length === 0) {
    return null
  }

  return (
    <Carousel
      aria-label={`${sectionName} carousel`}
      itemsPerPage={CAROUSEL_ITEMS_PER_PAGE}
      spaceBetweenItems={CAROUSEL_SPACE_BETWEEN_ITEMS}
      hideDisabledArrow
      arrowStyleVariant="shapeElevated"
      arrowSize="sm"
      carouselWrapperClassName={styles.carousel}
      itemWrapperClassName={styles.carouselItem}
      scrollerClassName={styles.scroller}
      dotsContainerClassName={styles.dotsContainer}
    >
      {cards.map((card, index) => (
        <div
          key={`${card.identifier ?? card.heading ?? 'contentful'}-carousel-card-${String(index)}`}
          className={classNames(styles.cardWrapper, {
            [styles.shortCard]: cardStyle === 'short',
          })}
        >
          <ContentfulCard {...card} eventData={eventData} cardStyle={cardStyle} />
        </div>
      ))}
    </Carousel>
  )
}
